module.exports = __webpack_public_path__ + "static/img/PARKSON_H5.6170137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/PARKSON_H5.png
// module id = TKiM
// module chunks = 34